<rt-group>
  <rt-button
    #followDropdownTrigger="rtOverlayOrigin"
    [loading]="loading()!"
    [pressed]="followDropdown.open"
    [rtTooltip]="tooltipText()"
    [rtTooltipPosition]="'below'"
    [rtTooltipMaxWidth]="244"
    (click)="followDropdown.toggleOverlay(true)"
    rt-overlay-origin
    variant="plain"
  >
    @if (!followed()) {
      <rt-icon name="bookmark-border" />
    } @else {
      <rt-icon name="bookmark" colorToken="colorIconSuccessDefault" />
    }
    <span class="status">{{ statusText() }}</span>
    @if (users()?.length) {
      <rt-admins-avatars
        rtTooltip
        [admins]="users()!"
        [limit]="2"
        [stacked]="true"
        [editable]="false"
        [moreButtonAsCounter]="true"
        [tooltipsEnabled]="false"
        [hasStopPropagation]="false"
        [counterAvatarTemplate]="followersCounterTpl"
        rtTooltipPosition="below"
        avatarSize="small-x"
        margin-left-small-xx
        margin-right-small-xxx
      />
    }
  </rt-button>
  <ng-template
    #followDropdown="rtConnectedOverlay"
    [origin]="followDropdownTrigger"
    [positions]="dropdownPositions"
    [minWidth]="320"
    (backdropClick)="followDropdown.toggleOverlay(false)"
    rt-connected-overlay
    hasBackdrop
  >
    <rt-dropdown>
      <rt-dropdown-item
        [hasHoverEffect]="false"
        (click)="$event.preventDefault()"
        data-cy="candidate-follow-button:dropdown:description"
      >
        <div layout-vertical>
          <rt-heading>{{ headingText() }}</rt-heading>
          <span class="dropdown-description">
            {{ descriptionText() }}
            <a [routerLink]="['settings', 'notifications']">{{
              'app.follow_dropdown.manage_followers.settings' | translate
            }}</a>
          </span>
        </div>
      </rt-dropdown-item>
      @if (followed()) {
        <rt-dropdown-item
          (click)="unfollowAction()"
          data-cy="candidate-follow-button:dropdown:followed"
        >
          <rt-icon name="bookmark-border" prefix />
          {{ 'app.follow_dropdown.unfollow' | translate }}
        </rt-dropdown-item>
      } @else {
        <rt-dropdown-item
          (click)="followAction()"
          data-cy="candidate-follow-button:dropdown:follow"
        >
          <rt-icon name="bookmark-border" prefix />
          {{ 'app.follow_dropdown.follow' | translate }}
        </rt-dropdown-item>
      }
      <rt-dropdown-item
        [rtTooltip]="'app.common.no_permission' | translate"
        [rtTooltipEnabled]="!canManageFollowers()"
        rtTooltipPosition="left"
        [rtTooltipMaxWidth]="284"
        [class.disabled]="!canManageFollowers()"
        [hasHoverEffect]="!!canManageFollowers()"
        (click)="canManageFollowers() && addFollowersAction()"
        data-cy="candidate-follow-button:dropdown:add_followers"
      >
        <rt-icon name="add" prefix />
        {{ 'app.follow_dropdown.manage_followers.add_followers' | translate }}
      </rt-dropdown-item>
      @if (users()?.length) {
        <rt-dropdown-item
          [hasHoverEffect]="false"
          (click)="$event.stopImmediatePropagation()"
          class="vertical-scroll"
          data-cy="candidate-follow-button:dropdown:followers"
        >
          <div layout layout-vertical>
            <rt-heading>{{
              'app.follow_dropdown.manage_followers.followers' | translate
            }}</rt-heading>
            @for (user of users()!; track user.id) {
              <div class="follower" data-cy="candidate-follow-button:dropdown:follower">
                <div class="name">
                  <rt-avatar
                    [type]="
                      user.anonymizedAt
                        ? 'icon'
                        : user.hasAvatar || !user.initials
                          ? 'image'
                          : 'initials'
                    "
                    [imageSrc]="user.photoThumbUrl"
                    [initials]="user.initials"
                    size="small-x"
                    shape="oval"
                    iconName="person"
                    context="admin"
                  >
                  </rt-avatar>
                  <span>{{ user.firstName }} {{ user.lastName }}</span>
                </div>
                @if (canManageFollowers()) {
                  <rt-icon-button
                    iconName="close"
                    variant="plain"
                    size="small"
                    (click)="removeFollowerClick.emit(user)"
                    [attr.data-cy]="'candidate-follow-button:dropdown:remove_follower:' + user.id"
                  />
                }
              </div>
            }
          </div>
        </rt-dropdown-item>
      }
    </rt-dropdown>
  </ng-template>
</rt-group>
<ng-template #followersCounterTpl let-count="count" let-hideOutline="hideOutline">
  <rt-total-followers-counter [count]="count ?? users()!.length" [hasOutline]="!hideOutline" />
</ng-template>
